export default __webpack_public_path__ + "static/Greenhouse_Double_Door-beeccfd02f930ac85b2aa820e2d6e484.png";